export default __webpack_public_path__ + "static/media/img-hero.ce251b70.png";